<audit-header></audit-header>
<div class="row viewRow">
    <div class="col-md-4"></div>
    <div class="col-md-4 colCenter">
<label>
    Application Id :
    <input type="text"  [(ngModel)] = "applicationId" /> 
</label>
<button type="button" class="auditButton" (click)="search()">Search</button>
<button type="button" class="auditButton" (click)="clear()" >Clear</button>
</div>
</div>  